export default __webpack_public_path__ + "static/media/CardTitleTarget.fbdabe47.svg";